import React from "react";
import { Outlet } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";

function ChurchSiteLayout() {
  return (
    <div className="church-site">
      <SiteHeader />
      <main className="church-site__main">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}

export default ChurchSiteLayout;
